<template>
  <div class="fuel">
    <div class="top fadein">
      <h1>Bezineverbruik</h1>
      <div class="add">
        <button @click="addingFuel = true">Opgeven</button>
      </div>
    </div>
    <div class="description">
      <p>Geef hier aan wanneer je hebt getankt.</p>
    </div>
    <div v-if="addingFuel" class="fadein">
      <h2>Opgeven</h2>
      <div class="field email">
        <label for="email">Liter:</label>
        <input type="number" v-model="liters">
      </div>
      <div class="save">
        <button @click="addingFuel = false; liters = 0">Annuleren</button>
        <button @click="save">Opslaan</button>
      </div>
    </div>
    <div v-else-if="fuel.length > 0" class="data fadein">
      <div>
        <p>Je hebt in totaal {{totalLiters}} liter getankt.</p>
      </div>
      <button @click="editing = !editing">Aanpassen</button>
      <p v-if="editing">Je aanpassingen worden automatisch opgeslagen.</p>
      <table>
        <thead>
          <th v-if="!editing">Datum</th>
          <th>Gebruiker</th>
          <th>Liter</th>
          <th v-if="editing">Verwijderen</th>
        </thead>
        <tbody>
          <tr v-for="fuel in filteredfuel" :key="fuel.id">
            <td v-if="!editing">{{new Date(fuel.timestamp).toLocaleDateString()}}</td>
            <td>{{fuel.userName}}</td>
            <td>
              <span v-if="editing && fuel.canEdit">
                <input type="number" v-model="fuel.liters" @change="update(fuel)">
              </span>
              <span v-else>{{fuel.liters}}</span>
            </td>
            <td v-if="editing">
              <span v-if="fuel.canEdit" class="delete" @click="deleteFuel(fuel)">verwijderen</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="fadein">
      <p>Er is nog geen verbruik opgegeven.</p>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode'

export default {
  name: 'Fuel',
  data() {
    return {
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      fuel: [],
      users: [],
      addingFuel: false,
      liters: 0,
      totalLiters: 0,
      editing: false
    }
  },
  methods: {
    deleteFuel(fuel) {
      if (confirm('Weet je zeker dat je dit verbruik wilt verwijderen?')){
        const token = localStorage.getItem('token');

        this.axios.delete(this.config.api + '/fuel/' + fuel.id, {
          headers: {
            authorization: token
          }
        })
          .then(() => {
            this.getFuel();
          })
          .catch((error) => {
            alert(error.message)
          })
      }
    },
    update(fuel) {
      const id = fuel.id;
      const timestamp = fuel.timestamp;
      const userId = fuel.userId;
      const liters = parseInt(fuel.liters, 10);

      const token = localStorage.getItem('token');

      this.axios.put(this.config.api + '/fuel', {
        id,
        timestamp,
        userId,
        liters
      }, {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        console.log(result);
      })
      .catch(() => {
        alert('Er is iets mis gegaan bij het bijwerken van je verbruik');
      })
    },
    save() {
      const timestamp = Date.now();
      const userId = this.userId;
      const liters = parseInt(this.liters, 10);

      const token = localStorage.getItem('token');

      this.axios.post(this.config.api + '/fuel', {
        timestamp,
        userId,
        liters
      }, {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        if (result.data.status){
          this.getFuel();
          this.addingFuel = false;
        }
        else alert(result.data.message)
      })
      .catch(() => {
        alert('Er is iets mis gegaan bij het bijwerken van je verbruik');
      })
    },
    getFuel() {
      const token = localStorage.getItem('token');
      this.global.GetBaseView().startLoad();

      this.axios.get(this.config.api + '/fuel', {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        this.fuel = result.data;
        this.totalLiters = 0;

        this.fuel.filter(fuel => fuel.userId === this.userId).forEach(fuel => this.totalLiters += fuel.liters)
        this.global.GetBaseView().endLoad();
      })
    },
    getUsers() {
      const token = localStorage.getItem('token');

      this.axios.get(this.config.api + '/users', {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        this.users = result.data;
      })
    }
  },
  computed: {
    filteredfuel: function() {
      return this.fuel.map(fuel => {
        const user = this.users.find(user => user.id === fuel.userId);

        return {
          id: fuel.id,
          userId: fuel.userId,
          liters: fuel.liters,
          timestamp: fuel.timestamp,
          userName: user ? `${user.firstname} ${user.lastname}` : '',
          canEdit: fuel.userId === this.userId
        }
      })
    }
  },
  created() {
    this.getFuel();
    this.getUsers();
  },
}
</script>

<style scoped>


.add > button {
  margin: 0 10px;
}

.save {
  margin-top: 20px;
  display: flex;
  justify-content: space-evenly;
}

.field {
  width: 100%;
  padding: 10px 0;

  display: flex;
  justify-content: space-between;
}

input {
  width: 70%;
}

.fuel {
  padding: 10px;
}

.top {
  display: flex;
  justify-content: space-between;
}

.add {
  display: flex;
  align-items: center;
}

.delete {
  color: red;
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/Fuel.vue